export const GAPIFY_ERROR = 'gapify:error';
export const GAPIFY_ON_MESSAGE = 'gapify:on-message';
export const GAPIFY_ON_START_CONVERSATION = 'gapify:on-start-conversation';
export const GAPIFY_READY = 'gapify:ready';
export const GAPIFY_POSTBACK = 'gapify:postback';
export const GAPIFY_OPENED = 'gapify:opened';
export const GAPIFY_CLOSED = 'gapify:closed';
